var _g;
import * as React from "react";
var SvgHomeawayCustom = function SvgHomeawayCustom(props) {
  return _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.404 3v7.53h9.005V3h2.437v18H16.41v-8.443H7.404V21H5V3z",
    fill: "#40A9FF",
    fillRule: "nonzero"
  })));
};
export default SvgHomeawayCustom;